import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App.tsx"
import "./i18n" // Initialize i18next
import "./styles/theme.css" // Tailwind + theme configuration


window.addEventListener('vite:preloadError', () => {
  /*
    metodo ufficiale per evitare l'error boundary ad ogni deply con vite
    https://vite.dev/guide/build#load-error-handling
  */
  console.log('%cEvent preloadError triggered', 'color: orange;')
  window.location.reload()
})

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
   <React.StrictMode>
      <App />
   </React.StrictMode>
)
